import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const defaultIncreaseCheck = change => change > 0;
const defaultDecreaseCheck = change => change < 0;

const VelocityChange = ({
  change,
  status,
  increaseIcon = 'hicon-positive-arrow',
  decreaseIcon = 'hicon-negative-arrow',
  stableIcon = 'hicon-waves',
  className,
  variant = 'default',
  increaseCheck = defaultIncreaseCheck,
  decreaseCheck = defaultDecreaseCheck,
}) => {
  let velocity = status;

  if (!status) {
    if (increaseCheck(change)) velocity = 'increase';
    else if (decreaseCheck(change)) velocity = 'decrease';
    else velocity = 'stable';
  }

  const icons = {
    increase: increaseIcon,
    decrease: decreaseIcon,
    stable: stableIcon,
  };

  return (
    <div className={cx('velocity-change', `velocity-${velocity}`, `variant-${variant}`, className)} data-testid="velocity-change">
      <span className={cx('velocity-change__icon', icons[velocity])} />
    </div>
  );
};

VelocityChange.propTypes = {
  change: T.oneOfType([T.string, T.number]),
  status: T.oneOf(['increase', 'decrease', 'stable']),
  increaseIcon: T.string,
  decreaseIcon: T.string,
  stableIcon: T.string,
  className: T.string,
  variant: T.oneOf(['default', 'filled']),
  increaseCheck: T.func,
  decreaseCheck: T.func,
};

export default VelocityChange;
